module.exports = "/_next/static/images/Hero@2x-75b0cda4d30e7977e861bfef3436cc44.png";